export const environment = {
  production: true,
  pathApi: 'https://adora.hes.staging.bpsafrica.com:8443',
  githubSha: 'a32a6ffccc92c7bd505735dd3490f344fefcb159',
  gmap_key: 'AIzaSyD3D0SdHzMW0BEUoDFRGWgFyrRK1fnd2LQ',
  environmentName: 'production',
  useOpenIddict: JSON.parse('true'),
};
